import template from './billable_events.html'
import controller from './billable_events.controller'
import './billable_events.scss'

const billableEventsComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template,
    controller
}

export default billableEventsComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/billable_events/billable_events.component.js